import * as H from "history";
import { FromLocationState } from "./types";

export function createFromLocationState(from: H.Location): FromLocationState {
    return { from };
}
